import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl, menuToggler } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { colors } from '../styles';
import HeaderMenu from './HeaderMenu';
import ContactModal from './ContactModal';

const styles = css`
  height: 70px;
  position: absolute;
  width: 100%;
  z-index: 100;
  .Header_freeBanner {
    position: absolute;
    z-index: 101;
    top: 30px;
    left: -85px;
    padding: 5px 80px;
    transform: rotate(-35deg);
    background-color: #DC1C4D;
    color: #FFFFFF;
    font-size: 21px;
    font-weight: 700;
    @media (min-width: 992px) {
      left: -75px;
      padding: 15px 80px;
    }
  }
  @media (min-width: 992px) {
    height: 100px;
  }
  .Header_logo {
    display: none;
    width: auto;
    height: 60px;
    position: absolute;
    top: 10px;
    left: 15px;
    @media (min-width: 992px) {
      height: 162px;
      top: -5px;
      padding: 30px;
      left: 60px;
      background-color: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
    }
    img {
      height: 100%;
    }
  }
  .Header_logoHorizontal {
    display: none;
    width: auto;
    height: 50px;
    position: absolute;
    top: 10px;
    left: 15px;
    @media (min-width: 1200px) {
      height: 70px;
      top: 15px;
      left: 40px;
    }
    img {
      height: 100%;
    }
  }
  .Header_search {
    display: none;
    position: absolute;
    right: 60px;
    top: 10px;
    z-index: 2;
    @media (min-width: 992px) {
      right: 0;
      top: 0;
    }
  }
  .Header_searchButton {
    width: 30px;
    height: 30px;
    border: 0;
    background-color: #FFFFFF;
    background-image: url('/images/icon-search.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 24px;
    @media (min-width: 992px) {
      height: 100px;
      width: 80px;
    }
  }
  .Header_searchResults {
    width: 100%;
    background-color: #000000;
    padding: 15px;
    position: fixed;
    top: 50px;
    left: 0;
    @media (min-width: 992px) {
      width: 300px;
      right: 0;
      top: 100px;
      left: auto;
    }
    input {
      width: 100%;
      padding: 4px 8px;
    }
    .results {
      list-style: none;
      margin: 10px 0 0 0;
      padding: 0;
      height: 200px;
      overflow-y: scroll;
      background-color: #FFFFFF;
      a {
        display: block;
        padding: 5px 10px;
        font-size: 14px;
        line-height: 1.1;
      }
    }
  }
  .Header_menuToggle {
    display: block;
    position: absolute;
    top: 21px;
    right: 15px;
    background: transparent;
    border: 0;
    padding: 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .Header_menuToggleIcon {
    width: 30px;
    height: 30px;
    position: relative;
    margin: 0 auto;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
  }

  .Header_menuToggleIcon span {
    display: block;
    position: absolute;
    height: 3px;
    width: 100%;
    background: ${colors.color2};
    border-radius: 2px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
  }
  .Header_menuToggleIcon span:nth-child(1) {
    top: 0px;
  }
  .Header_menuToggleIcon span:nth-child(2),.Header_menuToggleIcon span:nth-child(3) {
    top: 10px;
  }
  .Header_menuToggleIcon span:nth-child(4) {
    top: 20px;
  }
  .Header_menuToggleIcon.open span:nth-child(1) {
    top: 10px;
    width: 0%;
    left: 50%;
  }
  .Header_menuToggleIcon.open span:nth-child(2) {
    transform: rotate(45deg);
  }
  .Header_menuToggleIcon.open span:nth-child(3) {
    transform: rotate(-45deg);
  }
  .Header_menuToggleIcon.open span:nth-child(4) {
    top: 10px;
    width: 0%;
    left: 50%;
  }
  .OSCTag_wrapper {
    display: none;
    @media (min-width: 992px) {
      display: none;
      position: fixed;
      right: 0;
      top: 100px;
      background-color: ${colors.color3Darkest};
      cursor: pointer;
      z-index: 1;
    }
  }
  .OSCTag_image {
    width: 70px;
    height: 95px;
    float: left;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .OSCTag_content {
    float: left;
    padding: 10px 20px;
    position: relative;
    height: 95px;
  }
  .OSCTag_headline {
    font-weight: 300;
    font-size: 19px;
    color: #FFFFFF;
    letter-spacing: 0;
    span {
      font-size: 13px;
      color: #FFFFFF;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      font-weight: 800;
      display: block;
    }
  }
  .OSCTag_phone {
    color: #FFFFFF;
    background-color: ${colors.color3Dark};
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 8px 20px;
    width: 100%;
    font-size: 13px;
    line-height: 1;
    letter-spacing: 1px;
    background-image: url('/images/icon-red-box-white-arrow.svg');
    background-position: right center;
    background-repeat: no-repeat;
    background-size: auto 100%:
  }
`;

function Header({ builder, activateMenu, isActiveMenu }) {
  return (
    <div className={styles}>
      <div className="Header_freeBanner">FREE for 2020!</div>
      <button className="Header_menuToggle" onClick={activateMenu('header')}>
        <div className={`Header_menuToggleIcon ${isActiveMenu('header') ? 'open' : ''}`}>
          <span />
          <span />
          <span />
          <span />
        </div>
      </button>
      <HeaderMenu isActive={isActiveMenu('header')} toggleMenu={activateMenu('header')} />
      <ContactModal builder={builder}>
        <div className="OSCTag_wrapper">
          <div className="OSCTag_image" style={{ backgroundImage: `url('${buildThumbnailUrl(get(builder, 'osc_photo.contentUrl'), { width: 400, height: 400 })}')` }} />
          <div className="OSCTag_content">
            <div className="OSCTag_headline">
              Questions?
              <span>Get Fast Answers!</span>
            </div>
            <div className="OSCTag_phone">
              Call {get(builder, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}
            </div>
          </div>
        </div>
      </ContactModal>
    </div>
  );
}

Header.propTypes = {
  builder: PropTypes.object.isRequired,
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
};

export default withData(
  {
    builder: true,
  },
)(menuToggler(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js